import { Vector2 } from "three"

export const blurDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
export const SCALE_MULTIPLIER = 0.01
export const CMS_ELEMENT_TYPENAME = "__typename"
export const REVEAL_CLASSNAME = "reveal"

export const ENVIRONMENTS = Object.freeze({
	dev: "development",
	prod: "production",
})

///CURSOR

export const DOT_SIZE = 10 //pixels
export const AFTER_SIZE = DOT_SIZE / 2
export const CURSOR_EVENT = "mousemove"
export const CURSOR_ATTR = "data-cursor"
export const CURSOR_COLOR_ATTR = "data-cursor-color"
export const BLOB_RADIUS = SCALE_MULTIPLIER * 25
//three js units of measure (originally meters)
//with scaleMultiplier = 0.01, 1 stands for roughly 100 px

export const CURSOR_TYPES = Object.freeze({
	BLOB: "blob",
	LINK: "link",
	LINK_LOWERCASE: "link-lowercase",
	BUTTON: "button",
	BUTTON_WITHOUT_BORDER: "button-without-border",
	BUTTON_WITHOUT_BORDER_WHITE: "button-without-border-white",
	ELEVATOR: "elevator-bar",
	CIRCLE: "circle",
	CHIP: "chip",
	CHIP_LEFT: "chip-left",
	IMAGE: "image",
	HIDE: "hide",
	IMAGE3D: "image3D",
	TEXT3D: "text3D",
	THEME_CHANGE: "theme-change",
	FULL_CIRCLE: "full-circle",
	ROUNDED_OUTLINE: "rounded-outline",
	STICKY: "sticky",
	HTML: "html",
	SLIDER: "slider",
	SLIDER_OPEN: "slider_open",
	MARQUEE: "marquee",
	MARQUEE_EXPANDED: "marquee_expanded",
	CHECK: "check",
	CLOSE: "close",
	PILL: "pill",
	SOON: "soon",
	GO: "go",
	SERVICES_NEXT: "services-next",
	SERVICES_PREVIOUS: "services-previous",
	DIRECTIONAL_NEXT: "directional-next",
	DIRECTIONAL_PREVIOUS: "directional-previous",
})
export const CURSOR_INITIAL_TARGET = Object.freeze({
	el: null,
	type: CURSOR_TYPES.BLOB,
	blobScale: 1,
	position: new Vector2(0, 0),
	color: "secondary",
	size: {
		width: AFTER_SIZE,
		height: AFTER_SIZE,
	},
	scale: 1,
})

///CURSOR

export const ICONS = Object.freeze({
	LIST: "list",
	TILES: "tiles",
	WAVE: "wave",
	SHARPWAVE: "sharp-wave",
	CIRCULARWAVE: "circular-wave",
	MEDIUMWAVE: "medium-wave",
	HIGHWAVE: "high-wave",
	ARROWUP: "arrow-up",
	ARROWDOWN: "arrow-down",
	ARROWRIGHT: "arrow-right",
	PLEONIANSRECRUIT: "pleonians-recruit",
	PLEO_LOGO_DESIGN: "pleo-logo-design",
	PLEO_LOGO_DIGITAL: "pleo-logo-digital",
	PLEO_LOGO_METHOD: "pleo-logo-method",
	PLEO_LOGO_EXPO: "pleo-logo-expo",
	PLEO_LOGO_GROUP: "pleo-logo-group",
	WAVY_CIRCLE: "wavy-circle",
	HOME_LINE: "home-line",
	HOW_WE_CREATE_STORY_ARROW_DOWN_DESKTOP: "how-we-create-story-arrow-down-desktop",
	HOW_WE_CREATE_STORY_ARROW_DOWN_MOBILE: "how-we-create-story-arrow-down-mobile",
	ROCKET: "rocket",
	WE_ARE_PLEONIANS_TAG: "we-are-pleonians-tag",
	BUTTON_ARROW_RIGHT: "button-arrow-right",
	BUTTON_ARROW_LEFT: "button-arrow-left",
	SERVICE_CIRCLE_PART_BORDER: "service-circle-part-border",
	AREAS_OF_EXPERTISE_PIECE: "areas-of-expertise-piece",
	LONG_THIN_ARROW_LEFT: "long-thin-arrow-left",
	LONG_THIN_ARROW_RIGHT: "long-thin-arrow-right",
	SHORT_THIN_ARROW_LEFT: "short-thin-arrow-left",
	SHORT_THIN_ARROW_RIGHT: "short-thin-arrow-right",
	CROSS: "cross",
	PLEO_DESIGN_MENU_LOGO: "pleo-design-menu-logo",
	PLEO_GROUP_MENU_LOGO: "pleo-group-menu-logo",
	FEATURED_PROJECTS: "featured-projects",
	FEATURED_PROJECTS_PL: "featured-projects-pl",
	SOUND_ON: "sound-on",
	SOUND_OFF: "sound-off",
	THICK_WAVE: "thick-wave",
	PRELOADER: "preloader",
	SOON_MASK: "soon-mask",
	OPEN_IN_NEW_WINDOW_MODAL: "open-in-new-window_modal",
	COPY: "copy",
	X: "X",
	FACEBOOK: "fb",
	LINKEDIN: "linkedin",
	SHARE_ICON: "share-icon",
})

export const PADDING = Object.freeze({
	EXTRA_SMALL: "extra-small",
	SMALL: "small",
	MEDIUM: "medium",
	LARGE: "large",
	EXTRA_LARGE: "extra-large",
	NONE: "none",
})

export const LOCALES = Object.freeze({
	PL: "pl",
	EN: "en",
})

export const EASE = [0.16, 1, 0.3, 1]
export const CLOSE_MENU_ANIMATION_DURATION = 0 // miliseconds

export const PORTAL_LENS_RADIUS = 3 //units of 3D space

export const CURSOR_ASSET_SIZE = Object.freeze({
	LARGE: "large",
	SMALL: "small",
})

export const MIME_TYPE = Object.freeze({
	video: "video/mp4",
	image: "image/jpeg",
})

export const PLEO_TYPE = Object.freeze({
	DIGITAL: "digital",
	DESIGN: "design",
	GROUP: "group",
})

export const IMAGE_FALLBACK = Object.freeze({
	url: "",
	focalPoint: {
		x: 0.5,
		y: 0.5,
	},
	height: 0,
	width: 0,
	alt: "Image",
	blurUpThumb: "",
	placeholder: "empty",
	mimeType: "image/jpeg",
})

export const DEVICE_TYPES = Object.freeze({
	MOBILE: "mobile",
	TABLET: "tablet",
	DESKTOP: "desktop",
})

export const SCROLL_DIRECTION = Object.freeze({
	UP: "up",
	DOWN: "down",
})
